import React from 'react';
import ApplicationHeader from '../components/ApplicationHeader/ApplicationHeader';
import WhatIsFreshFundJudgesFull from '../components/WhatIsFreshFund/WhatIsFreshFundJudgesFull';
import WhatIsFreshFundJudgesIntro from '../components/WhatIsFreshFund/WhatIsFreshFundJudgesIntro';
import './about.scss';

import Footer from '../components/Footer';
import Metadata from '../components/Metadata/Metadata';
import ApplyNow from '../components/WhatIsFreshFund/ApplyNow';

const FreshfundJudges = () => (
  <div className='what-is-freshfund'>
    <Metadata />
    <ApplicationHeader />
    <WhatIsFreshFundJudgesIntro />
    <WhatIsFreshFundJudgesFull />
    <ApplyNow />
    <Footer />
  </div>
);
export default FreshfundJudges;
